<template>
  <div class="card">
    <h1>Ordens de Serviço | Extranet</h1>
    <Toast :style="{ width: $isMobile() ? '85vw' : '' }" />
    <div class="p-grid p-fluid dashboard p-jc-center p-mb-3">
      <W4MstreakIndicators
        :indicators="streakIndicators"
        :loader="indicatorLoading"
        v-on:W4MstreakIndicatorsClick="streakIndicatorsClick"
      />
    </div>
    <Sidebar
      class="p-sidebar-md"
      :dismissable="false"
      position="right"
      :visible.sync="showSidebar"
      @hide="
        () => {
          showSidebar = false;
          serviceOrder = null;
        }
      "
    >
    <DetailExtranet
      v-if="serviceOrder"
      :service-order="serviceOrder"
      @pat-created="onPatCreated"
    />
      <template #footer>
        <div class="flex items-center gap-2">
          <Button
            label="Account"
            icon="pi pi-user"
            class="flex-auto"
            outlined
          ></Button>
          <Button
            label="Logout"
            icon="pi pi-sign-out"
            class="flex-auto"
            severity="danger"
            text
          ></Button>
        </div>
      </template>
      <template #header>
        <div class="p-d-flex p-jc-between p-ai-center">
          <h3>Ordem de Serviço {{ serviceOrder.service_receipt_no }}</h3>
        </div>
      </template>
    </Sidebar>
    <div style="height: 65vh">
      <DataTable
        :value="serviceOrderList"
        :paginator="true"
        :rows="perPage"
        :rowsPerPageOptions="[10, 20, 50, 100]"
        :filters.sync="filters"
        filterDisplay="row"
        :loading="loading"
        class="p-datatable-sm"
        responsiveLayout="scroll"
        :scrollable="true"
        scrollHeight="flex"
        :autoLayout="true"
        stripedRows
        :lazy="true"
        :totalRecords="totalRecords"
        @page="fetchData"
        @sort="fetchData"
        @filter="fetchData"
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
        currentPageReportTemplate="Mostrar de {first} a {last} de {totalRecords} dados"
      >
        <template #empty> Não existem ordens de serviço. </template>
        <template #loading> A carregar. Por favor Aguarde... </template>
        <Column
          field="patId"
          header="PAT"
          sortable
          filterField="patId"
        >
          <template #body="slotProps">
            <div v-if="slotProps.data.patId && slotProps.data.patId !== 0">
              <a
                class="clickable-item"
                :href="`/pats/${slotProps.data.patId}`"
                target="_blank"
                rel="noopener"
                @click.stop
              >
                {{ slotProps.data.patId }}
              </a>
            </div>
            <div v-else>
              <span>-</span>
            </div>
          </template>
          <template #filter="{ filterModel, filterCallback }">
            <DebouncedFilterInput
              v-model="filterModel.value"
              :callback="filterCallback"
              placeholder="Filtrar por PAT"
            />
          </template>
        </Column>
        <Column
          field="id"
          header="Ordem de Serviço"
          sortable
          filterField="id"
        >
          <template #body="slotProps">
            <div>
              <span
                class="clickable-item"
                @click="
                  () => {
                    serviceOrder = slotProps.data;
                    showSidebar = true;
                  }
                "
                >{{ slotProps.data.id }}
              </span>
            </div>
          </template>
          <template #filter="{ filterModel, filterCallback }">
            <DebouncedFilterInput
              v-model="filterModel.value"
              :callback="filterCallback"
              placeholder="Filtrar por ordem"
            />
          </template>
        </Column>
        <Column
          field="client.name"
          header="Cliente"
          sortable
          filterField="client.name"
        >
          <template #filter="{ filterModel, filterCallback }">
            <DebouncedFilterInput
              v-model="filterModel.value"
              :callback="filterCallback"
              placeholder="Filtrar por cliente"
            />
          </template>
        </Column>
        <Column
          field="created_at"
          header="Data"
          sortable
          filterField="created_at"
        >
          <template #filter="{ filterModel, filterCallback }">
            <v-date-picker
              v-model="filterModel.value"
              :masks="{ input: 'DD-MM-YYYY' }"
              @input="(date) => onDateFilterChange(date, filterModel, filterCallback)"
            >
              <template v-slot="{ inputValue, inputEvents }">
                <input
                  class="p-inputtext p-component p-column-filter"
                  :value="inputValue"
                  v-on="inputEvents"
                  placeholder="Filtrar por data"
                />
              </template>
            </v-date-picker>
          </template>
        </Column>
        <Column
          field="equipment.brand"
          header="Marca"
          sortable
          filterField="equipment.brand"
        >
          <template #filter="{ filterModel, filterCallback }">
            <DebouncedFilterInput
              v-model="filterModel.value"
              :callback="filterCallback"
              placeholder="Filtrar por marca"
            />
          </template>
        </Column>
        <Column
          field="equipment.type"
          header="Tipo"
          sortable
          filterField="equipment.type"
        >
          <template #filter="{ filterModel, filterCallback }">
            <DebouncedFilterInput
              v-model="filterModel.value"
              :callback="filterCallback"
              placeholder="Filtrar por tipo"
            />
          </template>
        </Column>
        <Column
          field="equipment.model"
          header="Modelo"
          sortable
          filterField="equipment.model"
        >
          <template #filter="{ filterModel, filterCallback }">
            <DebouncedFilterInput
              v-model="filterModel.value"
              :callback="filterCallback"
              placeholder="Filtrar por modelo"
            />
          </template>
        </Column>
        <Column
          field="problem"
          header="Problema"
          sortable
          filterField="problem"
        >
          <template #filter="{ filterModel, filterCallback }">
            <DebouncedFilterInput
              v-model="filterModel.value"
              :callback="filterCallback"
              placeholder="Filtrar por problema"
            />
          </template>
        </Column>
      </DataTable>
    </div>
  </div>
</template>
<script>
import W4MstreakIndicators from "../components/W4Mstreak/W4MstreakIndicators.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import DetailExtranet from "../components/serviceOrders/DetailExtranet.vue";
import serviceOrdersService from "../services/serviceOrders.service";
import DebouncedFilterInput from "../components/elements/DebouncedFilterInput.vue";
import { FilterMatchMode } from "primevue/api/";
export default {
  name: "ServiceOrdersExtranet",
  components: {
    W4MstreakIndicators,
    DetailExtranet,
    DebouncedFilterInput,
  },
  data() {
    return {
      loading: false,
      createFromPatForm: false,
      showSidebar: false,
      indicatorLoading: false,
      currentState: {},
      serviceOrderList: [],
      totalRecords: 0,
      perPage: 20,
      serviceOrder: null,
      filters: {
        id: { value: null, matchMode: FilterMatchMode.CONTAINS },
        patId: { value: null, matchMode: FilterMatchMode.CONTAINS },
        'client.name': { value: null, matchMode: FilterMatchMode.CONTAINS },
        created_at: { value: null, matchMode: FilterMatchMode.CONTAINS },
        'equipment.brand': { value: null, matchMode: FilterMatchMode.CONTAINS },
        'equipment.type': { value: null, matchMode: FilterMatchMode.CONTAINS },
        'equipment.model': { value: null, matchMode: FilterMatchMode.CONTAINS },
        problem: { value: null, matchMode: FilterMatchMode.CONTAINS },
      },
    };
  },
  async created() {
    await this.initStreakIndicators();
    this.loading = false;
  },
  methods: {
    async initStreakIndicators() {
      this.indicatorLoading = true;
      this.streakIndicators = [
        {
          title: "Aceites",
          color: "#20d077",
          counter: 0,
        },
        {
          title: "Sem Pat",
          counter: 0,
        },
      ];
      this.streakIndicators = [
        {
          title: "Aceites",
          color: "#20d077",
          counter: await serviceOrdersService.countExtranetServiceAccepted(),
        },
        {
          title: "Sem Pat",
          counter: await serviceOrdersService.countExtranetServiceWithoutPat(),
        },
      ];
      this.indicatorLoading = false;

      if (this.currentState != {}) {
        return this.streakIndicatorsClick(this.currentState);
      }
    },
    async streakIndicatorsClick(info) {
      this.currentState = info;
      this.fetchData();
    },
    onDateFilterChange(date, filterModel, filterCallback) {
      if (date) {
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();

        filterModel.value = `${year}-${month}-${day}`;
      } else {
        filterModel.value = null;
      }

      filterCallback();
    },
    buildQueryParams(page = 1) {
      const filterFieldMap = {
        'patId': 'pat_id',
        'client.name': 'client_name',
        'equipment.brand': 'equipment_brand',
        'equipment.type': 'equipment_type',
        'equipment.model': 'equipment_model',
      };

      const params = new URLSearchParams();
      params.append('page', page);

      for (const [key, filter] of Object.entries(this.filters)) {
        if (filter.value !== null && filter.value !== '') {
          const backendKey = filterFieldMap[key] || key;
          params.append(`filters[${backendKey}]`, filter.value);
        }
      }

      return params;
    },
    async fetchData(event = {}) {
      if (!this.currentState.indicatorName) return;

      this.loading = true;
      const page = event.page != null ? event.page + 1 : 1;
      const params = this.buildQueryParams(page);
      params.append('per_page', event.rows || this.perPage);

      let response = null;
      if (this.currentState.indicatorName == "Aceites") {
        response = await serviceOrdersService.getExtranetServiceAccepted(params);
      } else if (this.currentState.indicatorName == "Sem Pat") {
        response = await serviceOrdersService.getExtranetServiceWithoutPat(params);
      }

      if (response) {
        this.serviceOrderList = response.data;
        this.totalRecords = response.meta ? response.meta.total : response.total;
        this.perPage = response.meta ? response.meta.per_page : response.per_page;
      }

      this.loading = false;
    },
    onPatCreated() {
      this.initStreakIndicators()
      this.streakIndicatorsClick({ indicatorName: "Sem Pat" });
      this.showSidebar = false;
      this.serviceOrder = null;
    },
  },
};
</script>
<style>
.p-sidebar-header-content {
  width: 100% !important;
}
</style>
